(function (Drupal) {
  Drupal.behaviors.copyToClipboard = {
    attach() {

      document.addEventListener('click', function (e) {

        const btn = e.target.closest('.copy-btn');
        if (!btn) return;

        e.preventDefault();

        const value = btn.dataset.copy;
        if (!value || !navigator.clipboard) return;

        const icon = btn.querySelector('.copy-icon');
        const check = btn.querySelector('.copy-check');

        navigator.clipboard.writeText(value).then(() => {

          // Swap icon
          if (icon && check) {
            icon.classList.add('d-none');
            check.classList.remove('d-none');
          }

          // Tooltip
          if (window.bootstrap && bootstrap.Tooltip) {
            let tooltip = bootstrap.Tooltip.getInstance(btn);
            if (!tooltip) {
              tooltip = new bootstrap.Tooltip(btn);
            }

            btn.setAttribute('data-bs-original-title', 'Copied!');
            tooltip.show();
          }

          // Reset after delay
          setTimeout(() => {
            if (icon && check) {
              icon.classList.remove('d-none');
              check.classList.add('d-none');
            }

            btn.setAttribute('data-bs-original-title', 'Copy');
          }, 1200);

        }).catch(() => {
          console.error('Copy failed');
        });

      });

    }
  };
})(Drupal);
